module.exports = require("./ms-BN.js");